import { useState } from "react";

import { Alert, Box, Button, Collapse, Grid, IconButton, TextField, Tooltip } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import CloseIcon from '@mui/icons-material/Close';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TipsAndUpdatesTwoToneIcon from '@mui/icons-material/TipsAndUpdatesTwoTone';
import es from "date-fns/locale/es";

export default function EditarDocumentosAdquisiciones(props) {
    const [errorCotizacion, setErrorCotizacion] = useState(false)
    const [helperTextCotizacion, setHelperTextCotizacion] = useState('')
    const [open, setOpen] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [cotizacion, setCotizacion] = useState(null)
    const [severity, setSeverity] = useState('error')

    const adquisicion = { ...props.adquisicion, documentos: new FormData() }

    const solicitud = { ...props.solicitud }

    const cargarDatosTabla = props.cargarDatosTabla

    //console.log(`JSON.stringify(adquisicion) ${JSON.stringify(adquisicion)}`)

    const [fechaExpiracion, setFechaExpiracion] = useState(props.adquisicion.fechaExpiracion)

    const handleSubmitCotizacion = async (e) => {
        e.preventDefault()
       
        if (cotizacion) {
            const archivos = new FormData();
            //console.log(`Antes de append ${cotizacion.name}`)
            archivos.append('cotizacion', cotizacion);

            const resUpload = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/uploadCotizaciones`, {
                method: "POST",
                body: archivos
            })

            const datos = await resUpload.json()
            //console.log(`Archivo guardado ${datos.ruta} fechaExpiracion ${fechaExpiracion}`)
            adquisicion.rutaCotizacion = datos.ruta
            adquisicion.fechaExpiracion = fechaExpiracion
        }
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/adquisicion/${adquisicion.id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            },
            body: JSON.stringify(adquisicion)
        })

        const data = await res.json()
        if (res.status === 200) {
            setFechaExpiracion(null)
            setSeverity('success')
        }
        else
            setSeverity('error')
        if (data.message) {
            setOpen(true)
            setMensaje(data.message)
            await cargarDatosTabla()
            return
        }
        else {
            setOpen(true)
            setMensaje("Se actualizó la cotización")
            await cargarDatosTabla()
        }
    }

    return (
        <form onSubmit={handleSubmitCotizacion}>
            <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                {solicitud.estado === 'registrada' || solicitud.estado === 'ajustesJefe'|| solicitud.estado === 'ajustesAsistente'  ?
                    <>
                        <Grid item xs={12} sm={12}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
                                <DatePicker label="Fecha de Expiración de la Cotización"
                                    value={`${fechaExpiracion}`}
                                    onChange={(newValue) => {
                                        setFechaExpiracion(newValue)
                                    }}
                                    renderInput={(params) => <TextField {...params} name="fechaExpiracion" id="fechaExpiracion" focused variant='outlined' style={{ width: '100%' }} required />}
                                />
                            </LocalizationProvider>
                            <Tooltip title={<> Fecha de vigencia especificada en la cotización </>} arrow><TipsAndUpdatesTwoToneIcon sx={{ color: 'orange' }} /></Tooltip>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField required label={`Cotización PDF`} id='cotizacion' name='cotizacion' focused type='file' accept="application/pdf" helperText={helperTextCotizacion} error={errorCotizacion} onChange={(event) => {
                                const file = event.target.files[0]
                                if (event.target.value) {
                                    if (event.target.value.endsWith(".PDF") || event.target.value.endsWith(".pdf")) {
                                        setHelperTextCotizacion('')
                                        setErrorCotizacion(false)
                                    }
                                    else {
                                        setHelperTextCotizacion('Formato de archivo no válido, se requiere PDF')
                                        setErrorCotizacion(true)
                                        return
                                    }
                                    if (file.size > 5242880) {
                                        setHelperTextCotizacion('El tamaño del archivo debe ser menor a 5MB')
                                        setErrorCotizacion(true)
                                        return
                                    }
                                    else {
                                        setHelperTextCotizacion('')
                                        setErrorCotizacion(false)
                                    }
                                    //console.log(`event.target.value.match(/[A-Za-z0-9_-]/gi) ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi)} ${event.target.files[0].name.match(/[A-Za-z0-9_-]/gi).length} cadena ${event.target.files[0].name.length}`)
                                    // Si la longitud coincide significa que sólo se encontraron letras, números y guiones
                                    /*if (file.name.match(/[A-Za-z0-9_-]/gi).length === file.name.length - 1) //Se resta uno por el punto de la extensión
                                    {
                                        setHelperTextCotizacion('')
                                        setErrorCotizacion(false)
                                    }
                                    
                                    else {
                                        setHelperTextCotizacion('El nombre del archivo no debe contener caracteres especiales como acentos o espacios en blanco, puede separar palabras con - o _')
                                        setErrorCotizacion(true)
                                        return
                                    }*/
                                }
                                //console.log(`Files[0] ${file.name}`)
                                setCotizacion(file)
                            }} sx={{ width: '100%' }} />
                        </Grid>
                    </>
                    : <></>
                }
              
                <Grid item sx={{ marginTop: 5 }}>
                    <Button variant='contained' color='primary' type='submit' disabled={ errorCotizacion}>
                        Actualizar
                    </Button>
                </Grid>
            </Grid>
            <Box sx={{ width: '100%' }}>
                <Collapse in={open}>
                    <Alert severity={severity}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        style={{ marginTop: 30 }}
                    >
                        {mensaje}
                    </Alert>
                </Collapse>
            </Box>
        </form>
    )
}